import {Component, Input} from '@angular/core';

@Component({
    selector: 'db-canvas-tour-tooltip',
    templateUrl: './canvas-tour-tooltip.component.html',
    styleUrl: './canvas-tour-tooltip.component.scss',
    standalone: false
})
export class CanvasTourTooltipComponent {
  @Input() tour: any;
  @Input() oneLine: boolean = true;
}
